import { AgentExecutionError, LLMProviderError } from "./errors-CEDWDXew.js";
import { logWarn } from "./logging-B7X3yL0T.js";

//#region src/internal/agents/provider-fallback.ts
/**
* Run an optional embedded-agent rewrite and fall back to the caller's direct
* behavior when the agent cannot complete the rewrite.
*
* - `LLMProviderError`: expected provider outage/quota/config. Log a warning
*   and continue with the caller's direct behavior.
* - `AgentExecutionError`: unexpected agent failure that already created a
*   Sentry issue at the agent boundary. Fall back without filing another issue.
* - Other errors still bubble (for example programming errors outside the agent).
*/
async function withProviderFallback({ operation, fallback, onFallback, run }) {
	try {
		return await run();
	} catch (error) {
		if (error instanceof LLMProviderError) {
			logWarn(error, {
				loggerScope: ["agents", "provider-fallback"],
				contexts: { aiProviderFallback: { operation } }
			});
			onFallback?.();
			return fallback();
		}
		if (error instanceof AgentExecutionError) {
			logWarn(error, {
				loggerScope: ["agents", "provider-fallback"],
				contexts: { aiProviderFallback: {
					operation,
					unexpectedAgentFailure: true,
					eventId: error.eventId ?? null
				} }
			});
			onFallback?.();
			return fallback();
		}
		throw error;
	}
}

//#endregion
export { withProviderFallback };
//# sourceMappingURL=provider-fallback-L61Pbfxx.js.map